module.exports = __webpack_public_path__ + "img/Infografis_EN_06.8ae2a592.jpg";